import { useColorContext } from '../contexts/ColorContext';
import { ColorHistoryPanel } from '../components/ColorHistoryPanel';

export function HistoryTool() {
  const { setInput, result } = useColorContext();

  return (
    <ColorHistoryPanel
      onSelectColor={setInput}
      currentHex={result?.hex ?? ''}
    />
  );
}
